import { Alert, AlertTitle, Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Error500 = () => {
  const navigate = useNavigate()

  return (
    <Alert severity="warning" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height:'calc(100vh - 50px)'}}>
        <AlertTitle>500 Internal Server Error</AlertTitle>
        Couldn't connect to the server
        <Button size="small" color="warning" variant="contained" onClick={() => navigate('/')}>We will be back</Button>
    </Alert>
  )
}

export default Error500